import React, { HTMLProps } from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import Image from '../Image'

export interface StepType {
  id: string
  slug: string
}

export interface StepProps extends HTMLProps<HTMLDivElement> {
  item: StepType
}

const Step = ({ item, className }: StepProps) => {
    return (
        <div
            className={twMerge(
                'w-[calc(100vw-3rem)] md:w-[95%] flex-none text-black flex snap-start md:items-end last:mr-56 transition duration-300',
                className,
            )}
            id={`segment-${item.slug}`}
        >
            <div className={twMerge('grid md:grid-cols-2 content-start md:items-end w-full')}>
                <div className='flex flex-col justify-start md:justify-end md:pb-10 order-2 md:order-1 pt-6 md:pt-0'>
                    <FormattedMessage id={item.id} tagName='h2' />
                    <div className='text-sm leading-6 mt-8 md:max-w-[410px] '>
                        <FormattedMessage id={`${item.id}.description`} tagName='p' />
                    </div>
                </div>
                <div className='max-w-[520px] order-1 md:order-2 justify-self-end'>
                    <Image
                        draggable={false}
                        className='object-cover w-full h-full'
                        alt={item.id}
                        slug={item.slug}
                    />
                </div>
            </div>
        </div>
    )
}

export default Step
